import { render } from "./Shoppable.vue?vue&type=template&id=9e86813c"
import script from "./Shoppable.vue?vue&type=script&lang=js"
export * from "./Shoppable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__